import config from 'config';

// The search API only plans a pickup from a flight time when an airport is involved (DEV-13394).
const searchesByFlightTime = ({ start_address, end_address } = {}) =>
  !!config.SHOW_FLIGHT_TIME_FOR_AIRPORTS &&
  (start_address?.type === 'airport' || end_address?.type === 'airport');

export default searchesByFlightTime;
